<template>
    <div id="exchange-and-return" class="container">
        <SfBreadcrumbs
                :breadcrumbs="breadcrumbs"
                class="breadcrumbs"
        />

        <OrkLoader :loading="loading">
            <h2 v-if="error && !content" class="error-msg">{{ $t('serviceUnavailable') }}</h2>
            <div v-else-if="content" class="delivery">
                <SfHeading :level="1"
                           :title="content.marketing_exchange_return_title"
                           class="sf-heading--left">
                </SfHeading>
                <div class="content" v-html="content.marketing_exchange_return_content"></div>

            </div>
        </OrkLoader>
    </div>

</template>

<script>
import {SfBreadcrumbs, SfHeading} from "@storefront-ui/vue"
import Api from '@/api/Api';
import {OrkLoader} from "@/components/Ork";

export default {
    name: "ExchangeAndReturn",
    components: {
        SfHeading,
        OrkLoader,
        SfBreadcrumbs
    },
    data() {
        return {
            breadcrumbs: null,
            loading: false,
            error: false,
            content: null,
        }
    },
    created() {
        this.setBreadcrumbs();
        this.getContent();
    },
    methods: {
        setBreadcrumbs() {

            this.breadcrumbs = [{
                text: this.$i18n.t('Home'),
                link: '/'
            }, {
                text: this.$i18n.t('Exchange and return'),
            }];

        },
        getContent() {
            this.loading = true;
            Api.marketing.getExchangeAndReturn()
                .then((data) => {
                    this.content = data;
                })
                .catch((err) => {
                    this.error = true;
                }).finally(this.loading = false)

        }
    },
}
</script>

<style lang="scss" scoped>
.error-msg {
  text-align: center;
}

h1, h2, h3 {
  // text-transform: uppercase;
}

h2 {
  font-weight: bold;
  margin-top: var(--spacer-xl);
  margin-bottom: var(--spacer-lg);
}

h3 {
  font-weight: 500;
  margin-top: var(--spacer-lg);
  margin-bottom: var(--spacer-base);
}

p {
  margin: var(--spacer-base) 0;
}
</style>